import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Hero.scss";
import { FiMail, FiLinkedin } from "react-icons/fi";

function Hero() {
  return (
    <section className="froi-hero" aria-labelledby="froi-hero-heading">
      <Container>
        <Row className="align-items-center froi-hero__row">
          <Col lg={6} xl={6} className="froi-hero__content">
            <img
              className="froi-hero__image"
              src="/images/hero/hero_text.png"
              alt="froi_tagline"
            />
          </Col>

          <Col lg={6} xl={6} className="froi-hero__media">
            <div className="froi-hero__image-wrap">
              <img
                className="froi-hero__image"
                src="/images/hero/froi-hero.png"
                alt="froi-symbol-logo"
              />
            </div>
          </Col>
        </Row>
        {/* <hr className="hero_divider" />
        <div className="froi-hero__info">
          <p>
            FROI's Website is currently undergoing scheduled enhancements to
            integrate our latest research, strategic frameworks, and global
            insights.
          </p>

          <p className="froi-hero__return">
            We return on <strong>October 10, 2026</strong>
          </p>
          <img
            src="/images/hero/froi_loading.png"
            alt="froi_Return_Date"
            width={200}
            className="froi-hero__return_img"
          />
          <p className="froi-hero__contact">
            For inquiries:{" "}
            <a
              href="https://mail.google.com/mail/?view=cm&fs=1&to=info@froiglobal.org"
              target="_blank"
            >
              info@froiglobal.org
            </a>
          </p>
        </div> */}
      </Container>
    </section>
  );
}

export default Hero;
